export const DEFAULT_DRAG_HANDLE_SELECTOR = "drag-handle";
export const NO_DRAG_SELECTOR = "no-drag";
export const ARRIVAL_INSTRUCTIONS_MAX_LENGTH = 5000;
export const JOB_DESCRIPTION_MAX_LENGTH = 2000;

export const DAY_IN_MS = 86400000;
